/**
 * @generated SignedSource<<38e3157baf02697af8d8f50109ead5e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodyHeaderActions$data = {
  readonly login: string;
  readonly " $fragmentType": "IssueBodyHeaderActions";
};
export type IssueBodyHeaderActions$key = {
  readonly " $data"?: IssueBodyHeaderActions$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyHeaderActions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyHeaderActions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "225ce9debf213a379c05a5eb482a829d";

export default node;
